<ng-container *ngIf="abierto">

  <div class="backdrop"></div>

  <div class="modalPanelMd animated {{animacion}}">

    <div class="contenido">

      <!-- Título -->
      <div class="encabezadoModal">

        <div class="modalTituloSimple">
          {{'Tokens.Titulo' | translate}}
        </div>

      </div>

      <div class="modalContenido">

        <!-- datos -->
        <div>

          <div class="divisor8"></div>


          <dx-data-grid
            (onOptionChanged)="sistemaService.CambiarPaginacionTabla($event)"
            id="tablaTokens"
            [columnAutoWidth]="true"
            [dataSource]="tokens"
            [showColumnHeaders]="true">

            <dxo-export [enabled]="true" [fileName]="'Tokens.Titulo' | translate"></dxo-export>

            <dxo-search-panel
              [visible]="true"
              [width]="240"
              placeholder="{{'Buscar' | translate}}">
            </dxo-search-panel>

            <dxo-paging [pageSize]="sistemaService.tablaPaginacion"></dxo-paging>

            <dxo-pager
              [visible]="true"
              [allowedPageSizes]="sistemaService.tablaPaginacionPaginaSize"
              [displayMode]="sistemaService.tablaPaginacionModo"
              [showPageSizeSelector]="sistemaService.tablaPaginacionSelector"
              [showInfo]="sistemaService.tablaPaginacionInfo"
              [showNavigationButtons]="sistemaService.tablaPaginacionNavegacion">
            </dxo-pager>


            <dxi-column
              [sortIndex]="0"
              sortOrder="asc"
              dataField="Clave"
              caption="{{'Tokens.Token' | translate}}"
              alignment="center">

            </dxi-column>

            <dxi-column
              dataField="Descripcion"
              caption="{{'Tokens.Descripcion' | translate}}"
              alignment="center">

            </dxi-column>

          </dx-data-grid>


        </div>
      </div>

      <!-- footer -->
      <div class="modalFooter">

        <div class="contenidoFooter ">

          <button class="boton botonSM filledBlanco" (click)="CerrarModal()">
            {{'Cerrar' | translate}}
          </button>

        </div>

      </div>

    </div>
  </div>

</ng-container>
